import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { UserService, LoginData, QuproServiceError } from '@arpada/arp-lib-common-qupro';
import { PortalPropietarioService } from '../../services/portal-propietario.service';
import { UiService } from '../../services/ui.service';
import { MessagesService } from '../../services/messages.service';

@Component({
  selector: 'app-cambio-password',
  templateUrl: './cambio-password.component.html',
  styleUrls: ['./cambio-password.component.scss'],
})
export class CambioPasswordComponent implements OnInit {

  @Input() canCancel: boolean;

  cambioPassword = {
    newPassword: '',
    confirmNewPassword: ''
  };

  constructor(private modalCtrl: ModalController,
              private userService: UserService,
              private portalPropietarioService: PortalPropietarioService,
              private uiService: UiService,
              private messagesService: MessagesService,
              ) { }

  ngOnInit() {}

  onSubmitform() {
    this.userService.changePassword(this.cambioPassword.newPassword).subscribe( resp => {
      try {
        this.portalPropietarioService.loginAfterChangePassword(this.cambioPassword.newPassword)
          .subscribe( (loginData: LoginData) => {
            this.modalCtrl.dismiss();
            this.uiService.showSimpleMiddleToast(this.messagesService.getSuccessChangePassword(), 2000);
          }, (error: QuproServiceError) => {
            this.portalPropietarioService.logger.error(
              '[CambioPasswordComponent] Error (qupro) al intentar hacer login despues del cambio de contraseña.', error);
            const message: string = this.messagesService.canNotLoginAfterChangePasswordMessage();
            this.uiService.presentAlert(this.messagesService.getErrorHeaderLabel(),
                                        this.messagesService.getErrorChangePasswordHeader(), message);
            this.modalCtrl.dismiss();
          });
      } catch (error) {
        this.uiService.presentAlert(this.messagesService.getErrorHeaderLabel(),
                                    this.messagesService.getErrorChangePasswordHeader(), error.message);
        this.portalPropietarioService.logger.error(
          '[CambioPasswordComponent] Error (exception) al intentar hacer login despues del cambio de contraseña.', error);
      }
    }, (error: QuproServiceError) => {
      this.portalPropietarioService.logger.error('[CambioPasswordComponent] Error (qupro) al intentar cambiar de contraseña.', error);
      const message: string = this.messagesService.canNotChangePasswordMessage();
      this.uiService.presentAlert(this.messagesService.getErrorHeaderLabel(),
                                  this.messagesService.getErrorChangePasswordHeader(), message);
      this.modalCtrl.dismiss();
    });
  }

  salir() {
    this.modalCtrl.dismiss();
  }

}
